import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';

export const MY_FILES_SORT_OPTIONS = [
    { value: 'createdAt_desc', label: 'Newest First', icon: 'bi-sort-down' },
    { value: 'createdAt_asc', label: 'Oldest First', icon: 'bi-sort-up' },
    { value: 'name_asc', label: 'Name A–Z', icon: 'bi-sort-alpha-down' },
    { value: 'name_desc', label: 'Name Z–A', icon: 'bi-sort-alpha-up' },
];

function MyFilesToolbar({
    searchTerm,
    onSearchTermChange,
    sortOption,
    onSortChange,
    totalElements,
    onUploadClick,
}) {
    const [localSearch, setLocalSearch] = useState(searchTerm);

    useEffect(() => {
        setLocalSearch(searchTerm);
    }, [searchTerm]);

    const activeSort =
        MY_FILES_SORT_OPTIONS.find((option) => option.value === sortOption) || MY_FILES_SORT_OPTIONS[0];

    const handleSearchSubmit = () => {
        onSearchTermChange(localSearch.trim());
    };

    const handleClear = () => {
        setLocalSearch('');
        onSearchTermChange('');
    };

    return (
        <div className="my-files-toolbar">
            <div className="my-files-toolbar__row d-flex flex-wrap align-items-center gap-2">
                <div className="d-flex align-items-center gap-2 min-width-0 flex-shrink-0">
                    <h5 className="mb-0 fw-semibold text-dark">Your Library</h5>
                    <span className="ecx-page-chip flex-shrink-0">
                        <i className="bi bi-folder2-open"></i>
                        {totalElements} file{totalElements === 1 ? '' : 's'}
                    </span>
                </div>

                <div className="my-files-toolbar__actions d-flex flex-nowrap align-items-center gap-2 ms-auto">
                    <div className="input-group input-group-sm my-files-toolbar__search flex-shrink-0">
                        <span className="input-group-text bg-light border-end-0">
                            <i className="bi bi-search text-muted"></i>
                        </span>
                        <input
                            type="text"
                            className="form-control form-control-sm border-start-0 bg-light"
                            placeholder="Search files..."
                            value={localSearch}
                            onChange={(e) => setLocalSearch(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearchSubmit();
                                }
                            }}
                        />
                        <button type="button" className="btn btn-sm btn-accent" onClick={handleSearchSubmit}>
                            Search
                        </button>
                        {(localSearch || searchTerm) && (
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleClear}>
                                Clear
                            </button>
                        )}
                    </div>

                    <Dropdown align="end" className="flex-shrink-0">
                        <Dropdown.Toggle
                            variant="outline-secondary"
                            size="sm"
                            className="d-flex align-items-center gap-2 my-files-sort-toggle"
                        >
                            <i className={`bi ${activeSort.icon}`}></i>
                            <span className="d-none d-xl-inline">{activeSort.label}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow-sm" popperConfig={{ strategy: 'fixed' }} renderOnMount>
                            {MY_FILES_SORT_OPTIONS.map((option) => (
                                <Dropdown.Item
                                    key={option.value}
                                    active={sortOption === option.value}
                                    onClick={() => onSortChange(option.value)}
                                >
                                    <i className={`bi ${option.icon} me-2`}></i>
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                    <button type="button" className="btn btn-sm btn-accent flex-shrink-0" onClick={onUploadClick}>
                        <i className="bi bi-cloud-arrow-up me-1"></i>
                        <span className="d-none d-sm-inline">Upload Media</span>
                        <span className="d-inline d-sm-none">Upload</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default MyFilesToolbar;
